module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2zm2 16a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2H2zm18 0a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2H20zm0-18a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H20z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/window-1.js
// module id = 1502
// module chunks = 14